import { type Features, hasFeature } from '@/lib/features'
import { isIrisConfigured } from './use-iris-threads'

/**
 * Should this account see Iris? Iris is a plan feature (`features.iris`), read
 * from the billing account's entitlements — never per user. Folding in
 * `isIrisConfigured` keeps environments without the Iris service (no
 * `VITE_IRIS_BASE_URL`) on the generations experience.
 */
export function isIrisEnabled(features: Features): boolean {
  return isIrisConfigured && hasFeature(features, 'iris')
}
